import useFeatureFlags from './useFeatureFlags';

export default useFeatureFlags;
